export const INSTRUCTION_POLLING_LABELS = {
	SUCCESS_SESSION: 'Session deleted',
	SUCCESS_TEST: 'Test deleted',
	FAILURE: 'Deletion failed. Please retry.',
	TRANSIENT: 'Connection issue – still trying'
} as const;
